import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'WhatsApp',
  subtitle: 'Marketing',
  tagline: 'Reach Customers Instantly',
  icon: '💬',
  heroDesc: 'Connect directly with your customers through personalized WhatsApp campaigns. With 98% open rates, WhatsApp marketing is the most powerful direct communication channel for Indian businesses.',
  mainStat: '98%',
  mainStatLabel: 'Average open rate for WhatsApp messages vs 20% for email',
  subStats: [{ value: '10k+', label: 'Messages Delivered Daily' }, { value: '70%', label: 'Average Response Rate' }],
  features: [
    { icon: '📨', title: 'Bulk Messaging', desc: 'Send personalized messages to thousands of customers simultaneously with high deliverability.' },
    { icon: '🤖', title: 'WhatsApp Automation', desc: 'Automated welcome messages, follow-ups, and drip campaigns that run 24/7.' },
    { icon: '🎯', title: 'Targeted Campaigns', desc: 'Segment your audience and send the right message to the right people at the right time.' },
    { icon: '📋', title: 'WhatsApp Catalogues', desc: 'Showcase your products and services directly in WhatsApp for seamless shopping.' },
    { icon: '📊', title: 'Campaign Analytics', desc: 'Detailed delivery, read, and response rate reports for every campaign.' },
    { icon: '🔗', title: 'Click-to-WhatsApp Ads', desc: 'Integration with Meta Ads to drive traffic directly from Facebook/Instagram to WhatsApp.' },
  ],
  benefits: [
    { title: 'Instant Customer Reach', desc: 'Messages land directly in your customer\'s pocket with near-instant delivery and reading.' },
    { title: 'Highest Engagement Rate', desc: '98% open rates make WhatsApp the most effective channel for promotions and updates.' },
    { title: 'Cost-Effective Marketing', desc: 'Reach thousands of customers at a fraction of the cost of traditional or paid advertising.' },
    { title: 'Personal & Direct Communication', desc: 'The conversational nature of WhatsApp builds stronger customer relationships and trust.' },
  ],
  process: [
    { title: 'Database Building', desc: 'We help you build a quality, opt-in customer database for compliant messaging.' },
    { title: 'Campaign Strategy', desc: 'Define messaging goals, timing, segmentation, and call-to-action for each campaign.' },
    { title: 'Content Creation', desc: 'Compelling message copy, images, PDFs, and video content crafted for WhatsApp.' },
    { title: 'Campaign Execution', desc: 'Messages sent at optimal times with proper personalization for maximum impact.' },
    { title: 'Track & Optimize', desc: 'Monitor delivery, open, and response rates to improve future campaigns.' },
  ],
  whyChoose: [
    { icon: '✅', title: 'Compliant Messaging', desc: 'All campaigns follow WhatsApp Business Policy guidelines for safe, compliant delivery.' },
    { icon: '⚡', title: 'Fast Execution', desc: 'Campaigns can be set up and launched within 24 hours of approval.' },
    { icon: '🎨', title: 'Creative Content', desc: 'Professional message templates with images, PDFs, and rich media.' },
    { icon: '📊', title: 'Full Transparency', desc: 'Real-time campaign tracking with detailed performance reports.' },
  ],
  reviews: [
    { name: 'Nilesh Chavan', role: 'Restaurant Owner', text: 'We send daily specials to 2,000 customers via WhatsApp. Tables are booked within minutes every time!' },
    { name: 'Pooja Sharma', role: 'Boutique Owner', text: 'Our WhatsApp sale campaigns consistently generate 5x more orders than any other channel.' },
    { name: 'Deepak Thakur', role: 'Coaching Institute', text: '80% of our new admissions now come through WhatsApp campaigns managed by DMS.' },
  ],
  faq: [
    { q: 'Is WhatsApp marketing legal?', a: 'Yes, when done through proper opt-in databases and WhatsApp Business API, it is fully compliant and legal.' },
    { q: 'What types of messages can be sent?', a: 'Promotional offers, product launches, reminders, updates, catalogues, and personalized greetings.' },
    { q: 'What is the minimum contact list size?', a: 'We can start campaigns with as few as 100 contacts. The larger the list, the better the ROI.' },
  ],
};

export default function WhatsappMarketing() {
  return <ServiceTemplate data={data} />;
}
